import { resolveComponent, useRuntimeConfig, h } from "#imports";
const prefix = () => {
  const { public: { strapiBlocksRenderer } } = useRuntimeConfig();
  return strapiBlocksRenderer.blocksPrefix;
};
export const textInlineNode = (node) => {
  if (node.bold)
    return h(resolveComponent(prefix() + "BoldInlineNode"), () => node.text);
  if (node.italic)
    return h(resolveComponent(prefix() + "ItalicInlineNode"), () => node.text);
  if (node.underline)
    return h(resolveComponent(prefix() + "UnderlineInlineNode"), () => node.text);
  if (node.strikethrough)
    return h(resolveComponent(prefix() + "StrikethroughInlineNode"), () => node.text);
  if (node.code)
    return h(resolveComponent(prefix() + "CodeInlineNode"), () => node.text);
  return node.text;
};
export const linkInlineNode = (node) => {
  const linkComponent = resolveComponent(prefix() + "LinkInlineNode");
  return h(linkComponent, { url: node.url }, () => node.children.map((childNode) => {
    return textInlineNode(childNode);
  }));
};
export const defaultInlineNode = (node) => {
  if (node.type === "link") {
    return linkInlineNode(node);
  } else if (node.type === "text") {
    return textInlineNode(node);
  }
};
export const listItemInlineNode = (node) => {
  const listItemComponent = resolveComponent(prefix() + "ListItemInlineNode");
  return h(
    listItemComponent,
    () => node.children.map(
      (childNode) => defaultInlineNode(childNode)
    )
  );
};
export const headingBlockNode = (node) => {
  const headingComponent = resolveComponent(prefix() + "Heading" + node.level + "Node");
  return h(
    headingComponent,
    () => node.children.map(
      (childNode) => defaultInlineNode(childNode)
    )
  );
};
export const paragraphBlockNode = (node) => {
  const paragraphComponent = resolveComponent(prefix() + "ParagraphNode");
  return h(
    paragraphComponent,
    () => node.children.map(
      (childNode) => defaultInlineNode(childNode)
    )
  );
};
export const codeBlockNode = (node) => {
  const codeComponent = resolveComponent(prefix() + "CodeNode");
  return h(
    codeComponent,
    () => node.children.map(
      (childNode) => textInlineNode(childNode)
    )
  );
};
export const quoteBlockNode = (node) => {
  const quoteComponent = resolveComponent(prefix() + "QuoteNode");
  return h(
    quoteComponent,
    () => node.children.map(
      (childNode) => defaultInlineNode(childNode)
    )
  );
};
export const listBlockNode = (node) => {
  const listType = node.format === "ordered" ? "OrderedListNode" : "UnorderedListNode";
  const listComponent = resolveComponent(prefix() + listType);
  return h(listComponent, () => node.children.map(
    (childNode) => {
      if (childNode.type === "list") {
        return listBlockNode(childNode);
      } else if (childNode.type === "list-item") {
        return listItemInlineNode(childNode);
      }
    }
  ));
};
export const imageBlockNode = (node) => {
  const imageComponent = resolveComponent(prefix() + "ImageNode");
  return h(imageComponent, {
    image: node.image
  });
};
export const renderBlocks = (blockNodes) => {
  return blockNodes.map((blockNode) => {
    switch (blockNode.type) {
      case "heading":
        return headingBlockNode(blockNode);
      case "paragraph":
        return paragraphBlockNode(blockNode);
      case "code":
        return codeBlockNode(blockNode);
      case "list":
        return listBlockNode(blockNode);
      case "quote":
        return quoteBlockNode(blockNode);
      case "image":
        return imageBlockNode(blockNode);
    }
  });
};
